import { render, staticRenderFns } from "./ExamQuestionEdit.vue?vue&type=template&id=94f164fa&"
import script from "./ExamQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./ExamQuestionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports